import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createUpdateReducer } from '@ff-os/pdp-shared-redux/createUpdateReducer';
import { PdpState } from '@ff-os/pdp-shared-redux/store';

type Ui = {
    isGiftWindowOpen: boolean;
    showProjectIncompatible: boolean;
    arPreviewStatus: ArPreviewStatus;
    isArQrWindowOpen: boolean;
};

export type ArPreviewStatus = 'pending' | 'loading' | 'ready' | 'qrcode' | 'disabled';

export const { actions, reducer } = createSlice({
    name: 'ui',
    initialState: {
        isGiftWindowOpen: false,
        showProjectIncompatible: false,
        arPreviewStatus: 'pending' as ArPreviewStatus,
        isArQrWindowOpen: false
    },
    reducers: {
        overwrite: (state, action: PayloadAction<any>) => {
            return action.payload;
        },
        updateItem: createUpdateReducer<Ui>()
    }
});

export const createUiBindings = () => ({

    createSelector: <T>(selector: (state: Ui) => T) => createSelector(
        (state: PdpState) => state.ui as Ui,
        o => selector(o)),

    createUpdateAction: <TKey extends keyof Ui>(key: TKey) =>
        (value: Ui[TKey]) => actions.updateItem({ key, value })
});